import { Button } from "@components/ui/button";
import { Calendar } from "@components/ui/calendar";
import { CourseState } from "@utils/interface/journey.interface";
import React, { useEffect } from "react";
import TimePicker from "./TimePicker";
import { format, startOfDay } from "date-fns";

interface DateTimeProps {
  setDateTime: (e: any) => void;
  dateTime: CourseState[];
  onChange: (e: any) => void;
  open?: boolean;
  disabledPastDates?: boolean;
  setOpen?: (e: boolean) => void;
  value: CourseState | CourseState[];
  isMulti?: boolean;
  additionalFunctions?: () => void;
}

const index: React.FC<DateTimeProps> = ({
  setDateTime,
  isMulti = true,
  dateTime,
  disabledPastDates = true,
  additionalFunctions,
  onChange,
  setOpen,
  value,
}) => {
  console.log("NoJSON", value);
  const JSONedValue = typeof value === "string" ? JSON.parse(value) : value;
  console.log("JSONedValue", JSONedValue);

  const [date, setDate] = React.useState<Date | undefined>(new Date());
  const [startTime, setStartTime] = React.useState<string>("12:00 AM");
  const [endTime, setEndTime] = React.useState<string>("12:00 AM");

  // Initialize values when component mounts or value changes
  useEffect(() => {
    if (JSONedValue && !isMulti) {
      // For single mode, get the first item from array or the object itself
      const currentValue = Array.isArray(JSONedValue)
        ? JSONedValue[0]
        : JSONedValue;

      if (currentValue) {
        // Set the date
        if (currentValue.date) {
          const parsedDate = new Date(currentValue.date);
          setDate(parsedDate);
        }

        // Set the start time
        if (currentValue.startTime) {
          setStartTime(currentValue.startTime);
        }

        // Set the end time (if isMulti is true)
        if (currentValue.endTime) {
          setEndTime(currentValue.endTime);
        }
      }
    }
  }, [JSONedValue, isMulti]);

  console.log("startTime", startTime);

  return (
    <div className=" w-fit">
      <h2>Select Date and Time</h2>
      <span className="text-[14px] font-medium text-[#1f2937]">Start Time</span>
      <TimePicker time={startTime} setTime={setStartTime} />
      {isMulti && (
        <>
          <span className="text-[14px] font-medium text-[#1f2937]">
            End Time
          </span>
          <TimePicker time={endTime} setTime={setEndTime} />
        </>
      )}
      <Calendar
        mode="single"
        showOutsideDays={false}
        captionLayout="dropdown"
        selected={date}
        onSelect={(selectedDate) => {
          if (selectedDate) {
            // Use startOfDay to ensure we get the beginning of the selected day
            // in local timezone, avoiding any timezone conversion issues
            const localDate = startOfDay(selectedDate);
            setDate(localDate);
          }
        }}
        disabled={
          disabledPastDates
            ? (day) => day < startOfDay(new Date())
            : disabledPastDates
        }
        className={"flex justify-center  gap-2 w-[300px]"}
      />
      <div className="flex gap-2 items-center">
        <Button
          onClick={() => setOpen && setOpen(false)}
          variant={"outline"}
          className="border-[#1da077] text-[#1da077]"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            // Format the date as YYYY-MM-DD to avoid timezone issues
            const formattedDate = date ? format(date, "yyyy-MM-dd") : null;
            const newEntry = {
              startTime,
              endTime: isMulti ? endTime : "",
              date: formattedDate, // Store as string in YYYY-MM-DD format
            };
            const newDateTime = isMulti ? [...dateTime, newEntry] : [newEntry];
            setDateTime(newDateTime);
            onChange(newDateTime);
            setOpen && setOpen(false);
            additionalFunctions?.();
          }}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};

export default index;
